import React, { useEffect } from "react";
import { RiEditFill } from "react-icons/ri";
import { IoMdCloseCircle } from "react-icons/io";
import { FaAngleLeft } from "react-icons/fa6";
import { FaAngleRight } from "react-icons/fa";

const FinallReview = ({
  register,
  handleSubmit,
  errors,
  onSubmit,
  watch,
  setTabs,
  success,
  setSuccess,
  formData,
  categories,
}) => {
  const data = {
    businessName: formData?.businessName,
    email: formData?.email,
    phone: formData?.mobileNumber,
    country: formData?.country,
    currency: formData?.currency,
    location: formData?.location,
    businessType: formData?.businessType,
    documents: formData?.documents,
    beneficiaryName: formData?.beneficiaryName,
    profileupload: formData?.profileupload,
    backgroundprofile: formData?.backgroundprofile,
    bankName: formData?.bankName,
    accountNumber: formData?.accountNumber,
    ifscCode: formData?.ifscCode,
    passbookOrCancelledCheque: formData?.passbookOrCancelledCheque,
    storeName: formData?.storeName,
    description: formData?.description,
    categories: formData?.categories,
  };

  const values = watch();
  console.log(values);

  return (
    <div>
      {" "}
      <div className="relative   rounded-lg px-0 sm:px-4 py-6 ">
        {/* Cover Image */}
        <div className="w-full h-[100px] sm:h-[320px] rounded-lg overflow-hidden relative group">
          <img
            src={
              values.cover_image
                ? URL.createObjectURL(values.cover_image)
                : "/image/backgroundprofile.png"
            }
            alt="Cover"
            className="w-full h-[100px] sm:h-[280px] object-cover"
          />
          {/* <span className="absolute inset-0 flex items-center justify-center text-black font-semibold text-sm">
            1060 Width x 280 Height
          </span> */}
        </div>

        {/* Profile Image */}
        <div className="absolute -bottom-4 left-3 sm:-bottom-7 sm:left-6">
          <div className="flex items-center">
            <div className=" w-[70px] h-[70px]  sm:w-[170px] sm:h-[170px]   overflow-hidden ">
              <img
                src={
                  values.profile_image
                    ? URL.createObjectURL(values.profile_image)
                    : "/image/backgroundprofile.png"
                }
                alt="Profile"
                className="w-[70px] h-[70px] sm:w-full sm:h-full object-cover"
              />
            </div>

            <div className="mt-10 ml-7">
              <p className="text-lg font-semibold ">{values?.businessName}</p>
            </div>
          </div>
        </div>
      </div>
      <div className=" mx-auto p-0  sm:p-5 space-y-8 text-sm mt-4 sm:mt-10 ">
        <div className="space-y-5 mt-10 sm:mt-5">
          <div className="flex flex-row justify-between border-b-2">
            <p className="text-[17px] font-[600] text-[#095228]">
              Seller Information
            </p>
            <button onClick={() => setTabs(1)} className="text-xs">
              <RiEditFill className="text-[18px]" />
            </button>
          </div>
          <div>
            <div className="mt-3">
              <p className="text-gray-500 font-medium text-[14px]">
                Business Name
              </p>
              <p className="text-lg font-medium">{values?.name || "xxxxxxx"}</p>
            </div>

            <div className="mt-3 flex sm:flex-row flex-col gap-4 sm:gap-20">
              <div>
                <p className="text-gray-500 font-medium text-[14px]">Email</p>
                <p className="text-[14px] font-medium">
                  {values?.email || "xxxxxxx"}
                </p>
              </div>
              <div>
                <p className="text-gray-500 font-medium text-[14px]">
                  Mobile Number
                </p>
                <p className="text-[14px] font-medium">
                  {values?.mobile_number || "xxxxxxx"}
                </p>
              </div>
            </div>

            <div className="mt-3 flex sm:flex-row flex-col gap-4 sm:gap-20">
              <div>
                <p className="text-gray-500 font-medium text-[14px]">Country</p>
                <p className="text-[14px] font-medium">
                  {values?.country || "xxxxxxx"}
                </p>
              </div>
              <div>
                <p className="text-gray-500 font-medium text-[14px]">
                  Currency
                </p>
                <p className="text-[14px] font-medium">{values?.currency}</p>
              </div>
              <div>
                <p className="text-gray-500 font-medium text-[14px]">
                  Location
                </p>
                <p className="text-[14px] font-medium">
                  {values?.location || "xxxxxxx"}{" "}
                </p>
              </div>
            </div>
            <div className="mt-3 flex space-x-8">
              <div>
                <p className="text-gray-500 font-medium text-[14px]">
                  Business Type
                </p>
                <div className=" flex flex-row gap-3 mt-3 items-center ">
                  <img
                    src={
                      values?.Seller_type === "Business Seller"
                        ? "/image/sellericon.png"
                        : "/image/indidvilesell.png"
                    }
                    alt="Business"
                    className="w-[32px] h-[32px]"
                  />
                  <span className="font-medium text-[14px] mt-2">
                    {values?.Seller_type === "Business Seller"
                      ? "Business Seller"
                      : "Individual Seller"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Section: Verify Identity */}

        <div>
          <div className="flex flex-row justify-between border-b-2">
            <p className="text-[17px]  font-[600] text-[#095228]">
              Verify Your Identity
            </p>
            <button onClick={() => setTabs(2)} className="  text-xs">
              <RiEditFill className="text-[18px]" />
            </button>
          </div>

          <div>
            <div className=" mt-5">
              <span className="text-gray-500 font-medium">
                Government - Issued ID{" "}
              </span>
              <div className="flex items-center gap-2 mt-1">
                <a
                  href={`/image/backgroundprofile.png`}
                  className="text-blue-600 underline text-sm"
                >
                  {values?.govt_id?.name || "xxxxxxx"}
                </a>
                <button className="text-red-500 text-lg">
                  <IoMdCloseCircle />
                </button>
              </div>
            </div>
            <div className="  mt-5">
              <span className="text-gray-500 font-medium">
                Business Certificate (for Business Seller)
              </span>
              <div className="flex items-center gap-2 mt-1">
                <a
                  href={`/image/backgroundprofile.png`}
                  className="text-blue-600 underline text-sm"
                >
                  {values?.business_certificate?.name || "xxxxxxx"}
                </a>
                <button className="text-red-500 text-lg">
                  <IoMdCloseCircle />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Section: Bank Account Details */}

        <div>
          <div className="flex flex-row justify-between border-b-2">
            <p className="text-[17px]  font-[600] text-[#095228]">
              Bank Account Details
            </p>
            <button onClick={() => setTabs(2)} className="  text-xs">
              <RiEditFill className="text-[18px]" />
            </button>
          </div>
          <div className="space-y-5 mt-5">
            <div>
              <p className="text-gray-500 font-medium text-[14px]">
                Beneficiary Name
              </p>
              <p className="text-[14px] font-medium">
                {values?.account_holder_name || "xxxxxxx"}
              </p>
            </div>
            <div>
              <p className="text-gray-500 font-medium text-[14px]">Bank Name</p>
              <p className="text-[14px] font-medium">
                {values?.bank_name || "xxxxxxx"}
              </p>
            </div>
            <div>
              <p className="text-gray-500 font-medium text-[14px]">
                Account Number
              </p>
              <p className="text-[14px] font-medium">
                {values?.account_number || "xxxxxxx"}
              </p>
            </div>
            <div>
              <p className="text-gray-500 font-medium text-[14px]">
                IFSC or SWIFT Code
              </p>
              <p className="text-[14px] font-medium">
                {values?.routing_number || "xxxxxxx"}
              </p>
            </div>
            <div className=" mt-5">
              <span className="text-gray-500 font-medium">
                Passbook/Cancelled Cheque
              </span>
              <div className="flex items-center gap-2 mt-1">
                <a
                  href={`/image/backgroundprofile.png`}
                  className="text-blue-600 underline text-sm"
                >
                  {values?.passbook_cancelled_cheque?.name || "xxxxxxx"}
                </a>
                <button className="text-red-500 text-lg">
                  <IoMdCloseCircle />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Section: Store Setup */}
        <div>
          <div className="flex flex-row justify-between border-b-2">
            <p className="text-[17px]  font-[600] text-[#095228]">
              Set Up Your Store
            </p>
            <button onClick={() => setTabs(3)} className="  text-xs">
              <RiEditFill className="text-[18px]" />
            </button>
          </div>

          <div className="space-y-5 mt-5">
            <div>
              <p className="text-gray-500 font-medium text-[14px]">
                Store Name
              </p>
              <p className="text-[14px] font-medium">{values?.store_name}</p>
            </div>
            <div className="mb-4">
              <label className="font-semibold">Description</label>
              <div className="mt-1 border rounded-md p-2 min-h-[80px] text-gray-500">
                {values?.store_description || "Enter Description"}
              </div>
            </div>
            <div>
              <label className="font-semibold">Categories</label>
              <div className="flex flex-wrap gap-2 mt-2">
                {categories?.map((tag) => (
                  <span
                    key={tag}
                    className="bg-green-100 text-green-800 text-sm px-3 py-1 rounded-full border border-green-300"
                  >
                    {tag?.title}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Actions button */}
        <div className="flex justify-between pt-6">
          <button
            onClick={() => setTabs(3)}
            className="px-3 flex items-center gap-10 py-2 rounded-full bg-green-800 text-white hover:bg-green-900"
          >
            <span>
              <FaAngleLeft />
            </span>
            Back
          </button>
          <button className="px-6 py-2 rounded-full flex items-center gap-10 bg-[#74131C] text-white hover:bg-green-900">
            Submit
            <span>
              <FaAngleRight />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FinallReview;
